<template>
  <v-tooltip bottom color="white" max-width="400" close-delay="200">
    <template v-slot:activator="{ on, attrs }">
      <v-icon class="pl-1" v-bind="attrs" v-on="on">icon-label-questionmark</v-icon>
    </template>

    <slot />
  </v-tooltip>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class InfoTooltip extends Vue {}
</script>
